import React, { useState } from 'react';
import Footer from '../component/Footer';

const Contact = () => {
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [time, setTime] = useState("");
    const [address, setAddress] = useState("");
    const [contact, setContact] = useState("");

    const handleDoctorChange = (event) => {
        const doctor = event.target.value;
        console.log("Selected Doctor:", doctor);
        setSelectedDoctor(doctor);
        setTime("");
    };

    const handleTimeChange = (event) => {
        const selectedTime = event.target.value;
        console.log("Selected Time:", selectedTime);
        setTime(selectedTime);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log("Form Submitted:", { selectedDoctor, name, email, address, contact, time });

        let message = `Booking Details:\n`;
        message += `Doctor: ${selectedDoctor || "Not selected"}\n`;
        message += `Name: ${name}\n`;
        message += `Email: ${email || "Not provided"}\n`;
        message += `Address: ${address}\n`;
        message += `Contact Number: ${contact}\n`;
        message += `Preferred Time: ${time}\n`;

        const whatsappNumber = "9140458191";
        const whatsappURL = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappURL, '_blank');

        setSelectedDoctor(null);
        setName("");
        setEmail("");
        setTime("");
        setAddress("");
        setContact("");
    };

    const timeSlots = {
        "Dr. Mansi Shukul": {
            Morning: ["Mon Morning", "Wed Morning", "Fri Morning"],
            Evening: ["Tue Evening", "Thu Evening", "Sat Evening"],
        },
        "Dr. Garima Gupta": {
            Morning: ["Tue Morning", "Thu Morning", "Sat Morning"],
            Evening: ["Mon Evening", "Wed Evening", "Fri Evening"],
        },
    };

    return (
        <>
        <div className="container my-5">
            <div className="text-center mb-4">
                <h1 className="display-4">Contact Us</h1>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
                    </ol>
                </nav>
            </div>

            <div className="row g-4">
                <div className="col-lg-6">
                    <div className="card shadow-sm p-4">
                        <h2 className="card-title mb-4">Book Appointment</h2>
                        <div className="mb-3">
                            <h5>Select Doctor</h5>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="doctor1"
                                    name="doctor"
                                    value="Dr. Mansi Shukul"
                                    checked={selectedDoctor === "Dr. Mansi Shukul"}
                                    onChange={handleDoctorChange}
                                />
                                <label className="form-check-label" htmlFor="doctor1">
                                    Dr. Mansi Shukul
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="doctor2"
                                    name="doctor"
                                    value="Dr. Garima Gupta"
                                    checked={selectedDoctor === "Dr. Garima Gupta"}
                                    onChange={handleDoctorChange}
                                />
                                <label className="form-check-label" htmlFor="doctor2">
                                    Dr. Garima Gupta
                                </label>
                            </div>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="address" className="form-label">Address</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="contact" className="form-label">Contact Number</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    id="contact"
                                    value={contact}
                                    onChange={(e) => setContact(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="time" className="form-label">Preferred Time</label>
                                <select
                                    className="form-select"
                                    id="time"
                                    value={time}
                                    onChange={handleTimeChange}
                                    required
                                    disabled={!selectedDoctor}
                                >
                                    <option value="">Select time</option>
                                    {selectedDoctor && timeSlots[selectedDoctor] && (
                                        <>
                                            <optgroup label="Morning">
                                                {timeSlots[selectedDoctor].Morning.map((slot) => (
                                                    <option key={slot} value={slot}>
                                                        {slot}
                                                    </option>
                                                ))}
                                            </optgroup>
                                            <optgroup label="Evening">
                                                {timeSlots[selectedDoctor].Evening.map((slot) => (
                                                    <option key={slot} value={slot}>
                                                        {slot}
                                                    </option>
                                                ))}
                                            </optgroup>
                                        </>
                                    )}
                                </select>
                            </div>
                            <button type="submit" className="btn btn-dark w-100">Submit</button>
                        </form>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="card shadow-sm p-4">
                        <h2 className="card-title mb-4">Get In Touch</h2>
                        <p className="card-text">
                            Our team of experts can help answer any questions you might have.
                            Please fill out the form and a consultant will respond shortly.
                        </p>
                        <p className="card-text">
                            <strong>Address:</strong> 1/1, Vineet Khand, Opposite Jaipuria School, Gomtinagar,
                            Lucknow, Uttar Pradesh -226010
                        </p>
                        <p className="card-text">
                            <strong>Email:</strong> indusmaternity@gmail.com
                        </p>
                        <p className="card-text">
                            <strong>Phone:</strong> +91 9140458191, +91 8838291513
                        </p>
                    </div>
                </div>
            </div>

            <hr className="my-5" />
            <div className="ratio ratio-16x9" style={{ height: '400px' }}>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d56946.128003922575!2d81.01178282065432!3d26.86751518110099!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399be3c88d3e0393%3A0x42124284dd5ad552!2sMom&#39;s%20Express%20(Indus%20Maternity%20Centre)!5e0!3m2!1sen!2sin!4v1712924760002!5m2!1sen!2sin"
                    className="rounded"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Map"
                ></iframe>
            </div>

           
        </div>


 <Footer />

 </>
    );
};

export default Contact;